import "../../../../components/atoms/buttons/button.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "../../../../pages/login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";
import ModalMensajes from "../../modals/modalMensajes/ModalMensajes";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";
import { deleteBorrador } from "../../../services/DatoPersonalService";

const BorradoresActos = ({ borradores, setBorradores, error }) => {
  const [token] = useLocalStorage("token", "");
  const marginTop = {
    marginTop: "20px",
  };
  useEffect(() => {}, [token]);
  const [show, setShow] = useState({
    mensaje: false,
  });
  const handleClose = (e) => {
    setShow(false);
  };

  const eliminarBorrador = (id) => {
    setBorradores(borradores.filter((el) => el.xsolactadm !== id));
    deleteBorrador(id,"s1");
  };

  const navigate = useNavigate();
  const borVerEli = [
    {
      name: <div>Ver/Modificar</div>,
      cell: (row) => (
        <i
          className="fa-solid fa-eye fs-3 mx-4 px-3 cursorPointer faHover"
          onClick={() => {
            navigate(`/borradorActos/${row.xsolactadm}`, {
              state: { nombreBorrador: row.nombre },
            });
          }}
          tabIndex={0}
          role="button"
          title = "Ver o Modificar borrador"
          aria-label="Ver o Modificar borrador del acto de variación de datos personales"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate(`/borradorActos/${row.xsolactadm}`, {
                state: { nombreBorrador: row.nombre },
              });
            }
          }}
        ></i>
      ),
      sortable: true,
      left: true,
      grow: 1,
    },
    {
      name: "Documentación",
      cell: (row) => (
        <i
          className="fa-solid fa-file-circle-plus fs-3 mx-4 px-3 cursorPointer faHover"
          onClick={() => {
            navigate(`/documentosActos/${row.xsolactadm}`,{state: {tipoActo:"s1"}});
          }}
          tabIndex={0}
          title = "Ver documentación"
          role="button"
          aria-label="Ver documentación del borrador del acto de variación de datos personales"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate(`/documentosActos/${row.xsolactadm}`,{state: {tipoActo:"s1"}});
            }
          }}
        ></i>
      ),
      sortable: true,
      left: true,
      grow: 1,
      wrap:1
    },
    {
      name: "Presentar",
      cell: (row) => (
        <i
          className="fa-solid fa-file-powerpoint fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => {
            navigate(`/presentarBorradorActos/${row.xsolactadm}`,{state: {tipoActo:"s1"}});
          }}
          tabIndex={0}
          title = "Presentar borrador"
          aria-label="Presentar borrador del acto de variación de datos personales"
          role="button"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate(`/presentarBorradorActos/${row.xsolactadm}`,{state: {tipoActo:"s1"}});
            }
          }}
        ></i>
      ),
      sortable: true,
      left: true,
      grow: 1,
    },
    {
      name: <div className="ms-4 text-center" style={{ width: '100%' }}>Acciones</div>,
      cell: (row) => (<div className="ms-3 d-flex justify-content-center align-items-center" style={{ width: '100%' }}>
       <i
          className="fa-solid fa-print fs-3  cursorPointer faHover"
          onClick={() => {
            navigate(`/descargarBorradorActos/${row.xsolactadm}`,{state: {tipoActo:"s1"}});
          }}
          tabIndex={0}
          title = "Descargar borrador"
          aria-label="Descargar borrador del acto de variación de datos personales"
          role="button"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate(`/descargarBorradorActos/${row.xsolactadm}`);
            }
          }}
        ></i>
       <i
          className="fa-solid fa-xmark fs-1 mx-2 px-3 cursorPointer faHover rojo"
          onClick={() => {
            setShow({
              mensaje: true,
              content: "¿Desea eliminar el borrador?",
              contentBold: "",
              tipo: "tituloModal",
              aviso: true,
              funcion: eliminarBorrador,
              valorFuncion: row.xsolactadm,
              destinoAviso: null,
              destinoCerrar: null,
            });
          }}
          tabIndex={0}
          title = "Eliminar borrador"
          aria-label="Eliminar borrador del acto de variación de datos personales"
          role="button"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              setShow({
                mensaje: true,
                content: "¿Desea eliminar el borrador?",
                contentBold: "",
                tipo: "tituloModal",
                aviso: true,
                funcion: eliminarBorrador,
                valorFuncion: row.xsolactadm,
                destinoAviso: null,
                destinoCerrar: null,
              });
            }
          }}
        ></i>
      </div>
       
      ),
      sortable: true,
      left: true,
      grow: 1,
    }
    // {
    //   name: "Eliminar",
    //   cell: (row) => (
       
    //   ),
    //   sortable: true,
    //   left: true,
    //   grow: 3,
    // },
  ];

  return (
    <>
      <div className="container" style={{ marginTop: "0px" }} role="main" data-landmark-index="4">
        <div>
          <div style={marginTop}>
            {!error ? (
              <DataTable
                className="table-responsive"
                columns={[
                  ...ConstantesTabla.columnasBorradoresActos,
                  ...borVerEli,
                ]}
                data={borradores}
                pagination
                paginationComponentOptions={ConstantesTabla.paginacionOpt}
                noDataComponent={<span>No se encontró ningún Borrador</span>}
                customStyles={ConstantesTabla.customStyles}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                style={marginTop}
              />
            ) : (
              <p className="rojo">No se ha podido conectar con el servidor</p>
            )}
          </div>
        </div>
      </div>
      {show.mensaje ? (
        <ModalMensajes
          show={show.mensaje}
          handleClose={handleClose}
          titulo={show.titulo}
          tipo={show?.tipo}
          content={show?.content}
          content2={show?.content2}
          contentBold={show?.contentBold}
          otherContent={show?.otherContent}
          aviso={show?.aviso}
          destinoAviso={show?.destinoAviso}
          destinoCerrar={show?.destinoCerrar}
          valorFuncion={show?.valorFuncion}
          funcion={show?.funcion}
        ></ModalMensajes>
      ) : null}
    </>
  );
};

export default memo(BorradoresActos);
